import { ListenerEvent as PackageListenerEvent } from '@carvana/merch-native';

enum HomeListenerEvent {
  ExploreInView = 'explore_viewed_after_background_refresh'
}

export const ListenerEvent = {
  ...HomeListenerEvent,
  ...PackageListenerEvent
};

export type ListenerEventType = HomeListenerEvent | PackageListenerEvent;
